import React from 'react';

export const FilterSkeleton = ({ type = 'list' }) => {
    if (type === 'button') {
        return (
            <div className="animate-pulse">
                <div className="h-4 bg-gray-200 rounded mb-4 w-24"></div>
                <div className="flex flex-wrap gap-3">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="flex flex-col items-center">
                            <div className="w-16 h-16 bg-gray-200 rounded-lg mb-2"></div>
                            <div className="h-3 bg-gray-200 rounded w-12"></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    if (type === 'size') {
        return (
            <div className="animate-pulse">
                <div className="h-4 bg-gray-200 rounded mb-4 w-20"></div>
                <div className="grid grid-cols-4 gap-2">
                    {[...Array(8)].map((_, i) => (
                        <div key={i} className="h-10 bg-gray-200 rounded-md"></div>
                    ))}
                </div>
            </div>
        );
    }

    // Default list type
    return (
        <div className="animate-pulse">
            <div className="h-4 bg-gray-200 rounded mb-4 w-28"></div>
            <div className="space-y-3">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="flex items-center space-x-3">
                        <div className="w-5 h-5 bg-gray-200 rounded"></div>
                        <div className="h-3 bg-gray-200 rounded flex-1"></div>
                        <div className="h-3 bg-gray-200 rounded w-8"></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export const CollectionSkeleton = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 animate-pulse">
            {[...Array(12)].map((_, i) => (
                <div key={i} className="bg-white rounded-lg overflow-hidden shadow-sm">
                    <div className="w-full h-64 bg-gray-200"></div>
                    <div className="p-4 space-y-2">
                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                        <div className="h-5 bg-gray-200 rounded w-1/3"></div>
                    </div>
                </div>
            ))}
        </div>
    );
};
